/* @ngInject */
const rootCtrl = (
  $rootScope,
  $http,
  styles,
  utils,
  authService,
  $$account,
  homeMenu,
  mainMenu,
  consultMenu,
  maneuverMenu,
  accountMenu,
  scrappingMenu,
  settingMenu,
  images,
  labels,
  icons,
  userService,
  $state,
  routes,
  toaster,
  $$setting,
  $timeout
) => {
  $rootScope.homeMenu = homeMenu
  $rootScope.mainMenu = mainMenu
  $rootScope.consultMenu = consultMenu
  $rootScope.maneuverMenu = maneuverMenu
  $rootScope.accountMenu = accountMenu
  $rootScope.scrappingMenu = scrappingMenu
  $rootScope.settingMenu = settingMenu

  $rootScope.images = images
  $rootScope.utils = utils
  $rootScope.user = authService
  $rootScope.styles = styles
  $rootScope.labels = labels
  $rootScope.icons = icons
  $rootScope.$$setting = $$setting

  $http.defaults.headers.common.Authorization = authService.getToken()

  $rootScope.begin = () => {
    if (userService.isLog()) {
      $state.go(routes.consult.index.path)
    } else {
      $$account.ask.askLogin()
    }
  }

  $rootScope.$back = () => {
    window.history.back()
  }

  const retrieveSettings = () => {
    $timeout(async () => {
      const data = {
        userId: authService.getUid(),
      }

      try {
        const response = await $$setting.requests.getBySearch(data)
        const settings = response.settings
        $$setting.format.updateLocalWithDatabase(settings)
        $$setting.format.updateGeneralWithDatabase(settings)
      } catch (error) {
        toaster.error(error)
      }
    })
  }
  retrieveSettings()

  $rootScope.version = '2.0.11'
}

export default rootCtrl



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/root.controller.js